import ListFilter from "assets/svgs/list_filter/ListFilter";
import React, { useState } from "react";
import { Button, Col, Dropdown, Form } from "react-bootstrap";
import AssignedOrderFilter from "./AssignedOrderFilter";
import { useLocation } from "react-router-dom";
import { Select } from "antd";
import { getCurrentUserRole, roles } from "modules/utilities/utility";

function TableHeader({
  assignedOrder,
  setFilterBy,
  setQueryParams,
  setPageNumber,
  setClear,
  setUnansFilter,
  unansFilter,
  sort,
  setSort,
}) {
  const [calls, setCalls] = useState([
    "IVR_BOOKING",
    "SLOT_BOOKING",
    "feedback",
    "slot_booking_total",
  ]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const headStyle = assignedOrder ? "" : "h-10 mt-n3";
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");

  const handleReset = () => {
    setCalls([]);
    setFilterBy([]);
    setDropdownOpen(false);
  };

  const handleCheckboxClick = (call) => {
    if (!calls.includes(call)) {
      setCalls([...calls, call]);
    } else {
      setCalls(calls?.filter((keyword) => keyword !== call));
    }
  };

  const handleDropdownToggle = (isOpen) => {
    setDropdownOpen(isOpen);
  };

  const handleOKClick = () => {
    setFilterBy(calls);
    setDropdownOpen(false);
  };

  const handleDropdownHide = () => {
    setDropdownOpen(false);
  };
  const handleSortCheckboxChange = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newSortOrder);
  };
  return (
    <div className={headStyle}>
      <div
        style={{ background: "#F9FAFD" }}
        className="d-flex flex-row border p-3 rounded-top"
      >
        <Col className="flex-1">
          <h5>Name</h5>
        </Col>

        <Col className="flex-1">
          <div className="d-flex justify-content-between">
            {getCurrentUserRole() !== "medical" && (
              <span className="fw-bold ms-4">Tags</span>
            )}
            {!window.location.href.includes("tab") ? (
              <div className="mt-n2">
                <AssignedOrderFilter
                  setQueryParams={setQueryParams}
                  setPageNumber={setPageNumber}
                  setClear={setClear}
                />
              </div>
            ) : null}

            {!assignedOrder && getCurrentUserRole() !== "medical" && (
              <Dropdown
                navbar={true}
                onToggle={handleDropdownToggle}
                onHide={handleDropdownHide}
                show={dropdownOpen}
              >
                <Dropdown.Toggle
                  bsPrefix="toggle dropdown-toggle-icon border-0"
                  style={{ background: "#F9FAFD" }}
                  className="pe-0 ps-2 nav-link"
                >
                  <ListFilter />
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdown-caret dropdown-menu-card dropdown-menu-end">
                  <Form
                    style={{ width: "12rem" }}
                    className="bg-white rounded-2 py-2 mx-2 d-flex flex-column align-items-center"
                  >
                    <Form.Check
                      type="checkbox"
                      id="ivr-checkbox"
                      label="IVR Booking"
                      className="mx-2 pe-2 text-black w-100"
                      onClick={() => handleCheckboxClick("IVR_BOOKING")}
                      checked={calls.includes("IVR_BOOKING")}
                    />
                    <Form.Check
                      type="checkbox"
                      id="slot-booking-checkbox"
                      label="Slot Booking"
                      className="mx-2 pe-2 text-black w-100"
                      onClick={() => handleCheckboxClick("SLOT_BOOKING")}
                      checked={calls.includes("SLOT_BOOKING")}
                    />
                    <Form.Check
                      type="checkbox"
                      id="feedback-checkbox"
                      label="Feedback Booking"
                      className="mx-2 pe-2 text-black w-100"
                      onClick={() => handleCheckboxClick("feedback")}
                      checked={calls.includes("feedback")}
                    />
                    <Form.Check
                      type="checkbox"
                      id="total-slot-checkbox"
                      label="Slot Booking Total"
                      className="mx-2 pe-2 text-black w-100"
                      onClick={() => handleCheckboxClick("slot_booking_total")}
                      checked={calls.includes("slot_booking_total")}
                    />
                    <div className="d-flex justify-content-between w-100">
                      <Button
                        size="sm"
                        variant="secondary"
                        onClick={handleReset}
                      >
                        Reset
                      </Button>
                      <Button size="sm" onClick={handleOKClick}>
                        OK
                      </Button>
                    </div>
                  </Form>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {getCurrentUserRole() === "medical" && (
              <>
                <Form.Check
                  type="checkbox"
                  id="sort-checkbox"
                  label="Sort by Last called(Ascending)"
                  className="mx-2 pe-2 text-black w-100"
                  onClick={() =>
                    setSort((prevFilter) => (prevFilter === "desc" ? "asc" : "desc"))
                  }
                  checked={sort === "asc"}
                />

                <Dropdown
                  navbar={true}
                  onToggle={handleDropdownToggle}
                  onHide={handleDropdownHide}
                  show={dropdownOpen}
                >
                  <Dropdown.Toggle
                    bsPrefix="toggle dropdown-toggle-icon border-0"
                    style={{ background: "#F9FAFD" }}
                    className="pe-0 ps-2 nav-link"
                  >
                    <ListFilter />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-caret dropdown-menu-card dropdown-menu-end">
                    <Form
                      style={{ width: "12rem" }}
                      className="bg-white rounded-2 py-2 mx-2 d-flex flex-column align-items-center"
                    >
                      <Form.Check
                        type="checkbox"
                        id="unanscount-0"
                        label="unanswered count 0"
                        className="mx-2 pe-2 text-black w-100"
                        onClick={() =>
                          setUnansFilter((prevFilter) =>
                            prevFilter === "0" ? "" : "0"
                          )
                        }
                        checked={unansFilter === "0"}
                      />
                      <Form.Check
                        type="checkbox"
                        id="unanscount-1"
                        label="unanswered count 1"
                        className="mx-2 pe-2 text-black w-100"
                        onClick={() =>
                          setUnansFilter((prevFilter) =>
                            prevFilter === "1" ? "" : "1"
                          )
                        }
                        checked={unansFilter === "1"}
                      />
                      <Form.Check
                        type="checkbox"
                        id="unanscount-2"
                        label="unanswered count 2"
                        className="mx-2 pe-2 text-black w-100"
                        onClick={() =>
                          setUnansFilter((prevFilter) =>
                            prevFilter === "2" ? "" : "2"
                          )
                        }
                        checked={unansFilter === "2"}
                      />
                      <div className="d-flex justify-content-between w-100"></div>
                    </Form>
                  </Dropdown.Menu>
                </Dropdown>
              </>
            )}
          </div>
        </Col>

        {!assignedOrder && getCurrentUserRole() !== "medical" && (
          <Col className="flex-1 text-center">Actions</Col>
        )}
      </div>
    </div>
  );
}

export default TableHeader;
